export default __webpack_public_path__ + "64d8be8cb58c424d6a84a1440d1dea05.png";